export function log(level, message) {
  if (process.env.NODE_ENV !== "production") {
    if (level === "error") {
      console.error(message);
    } else if (level === "warn") {
      console.warn(message);
    } else if (level === "info") {
      console.info(message);
    } else if (level === "trace") {
      console.trace(message);
    } else {
      console.log(message);
    }
  }
}

export default {
  install(Vue) {
    Vue.prototype.$console = log;
  }
};
